module.exports = "/images/logo-bas-01-540338ad32ab153fc48a15a984d7f034.jpg";